/*
 * @Describe:
 * @Author: wangalong
 * @LastEditTime: 2022-10-14 14:11:00
 */
const state = {
    showDownload: true,
    onAutoRenewalToken: false,
    showOpenInBrowser: false,
    kbRequestError: {
        visible: false,
        image: 'error',
        description: '页面出了点问题',
        retry: true,
    },
}

const getters = {
    getShowDownload: (state) => {
        return state.showDownload
    },
    getOnAutoRenewalToken: (state) => {
        return state.onAutoRenewalToken
    },
    getKbRequestError: (state) => {
        return state.kbRequestError
    },
}

const mutations = {
    SET_SHOW_DOWNLOAD: (state, showDownload) => {
        state.showDownload = showDownload
    },
    SET_ON_RENEWAL_TOKEN: (state, onAutoRenewalToken) => {
        state.onAutoRenewalToken = onAutoRenewalToken
    },
    SET_KB_REQUEST_ERROR: (state, kbRequestError) => {
        state.kbRequestError = kbRequestError
    },
    SET_KB_REQUEST_ERROR_VISIBLE: (state, visible) => {
        state.kbRequestError.visible = visible
    },
    SET_OPEN_IN_BROWSER: (state, visible) => {
        state.showOpenInBrowser = visible
    },
}

const actions = {
    updateShowDownload(context, showDownload) {
        context.commit('SET_SHOW_DOWNLOAD', showDownload)
    },
    updateOnAutoRenewalToken(context, onAutoRenewalToken) {
        context.commit('SET_ON_RENEWAL_TOKEN', onAutoRenewalToken)
    },
    updateKbRequestErrorVisible(context, visible) {
        context.commit('SET_KB_REQUEST_ERROR_VISIBLE', visible)
    },
    updateKbRequestError(context, kbRequestError) {
        context.commit('SET_KB_REQUEST_ERROR', kbRequestError)
    },
    updateOpenInBrowser(context, showOpenInBrowser) {
        context.commit('SET_OPEN_IN_BROWSER', showOpenInBrowser)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
